import React, { useState, useEffect } from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import '../styles/GridModal.css';
import AddCartMobile from './AddCartMobile';

const ModalBoxPopupMobile = ({ Modal, detailModalShow, handleDetailModalClose, Button, currentImage, product,qualityName  }) => {
  const [isLoading, setIsLoading] = useState(true); // Loading state
  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
    }, 10); 
  }, []);

  return (
    <>
      <Modal show={detailModalShow} onHide={handleDetailModalClose} fullscreen centered>
        <Modal.Body className="text-center modelboxoverflow" style={{padding:"0"}}>
          <Modal.Header style={{padding:"0",justifyContent:"space-between",Display:"flex"}} className="bottom-011">
            <span style={{marginLeft:"0%"}}>
              <b style={{
              color: "#E13236",
              fontWeight: 600,
              }}>{qualityName}</b> - &nbsp;  
              {product?.designshade?.split(" ").map((word, index, words) => (
              <React.Fragment key={index}>
              {index === 0
              ? word.split(/(\d+)/).map((part, i) =>
              /^\d+$/.test(part) ? (
              <span key={i}>{part}</span>
              ) : (
              <strong key={i}>{part}</strong>
              )
              )
              : word}

              {index < words.length - 1 && " "}
              </React.Fragment>
              ))}
              </span>
               <Button
            variant="light"
            onClick={handleDetailModalClose}
            className="top-0 end-0 close-btns btn btn-light"
            style={{ zIndex: 1050 }}
          >
            <i className="bi bi-x-lg"></i>
          </Button>
          </Modal.Header>
         
          <div className="box-Content-Ration">
            <div className="row">
              <div className="col-md-4">
                <div className="image-gallery position-relative">
                  {isLoading ? (
                    <Skeleton height={400} width="100%" />
                  ) : currentImage ? (
                    <img
                      src={currentImage}
                      alt="Detailed View"
                      style={{ width: '65%', height: '280px',margin:'0 auto' }}
                    />
                  ) : (
                    <p>No detailed data available.</p>
                  )}
                </div>
               <h3 className="text-xl text-gray-500" style={{ fontSize: "16px" }} >
              {isLoading ? (
              <Skeleton width={150} />
              ) : (
              <>

              
              </>
              )}
               </h3>
              </div>
              <div className="col-md-8">
              <div className="text-left">
                 <AddCartMobile sizes={product?.sizes || []}/> 
                 </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>

    </>
  );
};

export default ModalBoxPopupMobile;


